import React, { useState, useMemo } from "react";
import ProductSelector from "../../../parts/categories/product-selector";
import submit from "submit-form";
import {
  calculateFreeTrialDaysLeft,
  isCoachFreeTrial,
  isPullActiveCoach,
} from "../../../utils/user-helpers";

const SearchBar = ({ query, onChange }) => {
  return (
    <input
      type="search"
      value={query}
      onChange={({ target: { value } }) => onChange(value)}
      placeholder="Search exercise"
      data-expandable
    />
  );
};

const TutorialItem = ({ tutorial }) => {
  const { _id, name } = tutorial;

  const handleOpenTutorial = () => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "tutorial-detail",
        selectedTutorial: _id,
      },
    });
  };

  return (
    <li onClick={() => handleOpenTutorial()}>
      <img src="/img/new-icons/play-with-gradient.svg" className="icon-green" />
      <p className="p1">{name}</p>
    </li>
  );
};

const CategoryItem = ({ name, tutorials, noResults = false }) => {
  return (
    <article>
      {noResults ? <p className="s1">Showing results for:</p> : null}
      <p className="s1">{name}</p>
      {!noResults ? (
        <ul className="tutorials-container">
          {tutorials.length ? (
            tutorials.map((tutorial, idx) => (
              <TutorialItem tutorial={tutorial} key={idx} />
            ))
          ) : (
            <span className="no-tutorials">
              No tutorials available for this category
            </span>
          )}
        </ul>
      ) : null}
      {noResults ? (
        <div className="not-found">
          <img src="/img/svg/not-found.svg" alt="not-found" />
          <span className="not-found-title">SORRY</span>
          <span className="not-found-results">No result found</span>
        </div>
      ) : null}
    </article>
  );
};

const MSBUniversity = ({ allCategories, allVideos }, { locals }) => {
  const {
    query: { product },
    activeUser,
  } = locals;
  const [query, setQuery] = useState("");

  const hasFreeTrial =
    isCoachFreeTrial(activeUser) && calculateFreeTrialDaysLeft(activeUser) > 0;
  const isActivePull = isPullActiveCoach(activeUser);
  const isActivePush = Boolean(activeUser.pushAccountInfo);

  const getCategoryVideos = (category) => {
    if (!allVideos) return [];
    return allVideos.filter((video) => video.category === category);
  };

  const handleSearchBar = (value) => {
    setQuery(value);
  };

  const filteredCategories = useMemo(
    () =>
      allCategories.filter((category) => {
        const matchByCategoryName = category.name
          .toLowerCase()
          .includes(query.toLowerCase());
        const matchByTutorialName = getCategoryVideos(category.name).some(
          (video) => video.name.toLowerCase().includes(query.toLowerCase())
        );
        return matchByCategoryName || matchByTutorialName;
      }),
    [query, allCategories]
  );

  return (
    <main className="msb-university">
      <header>
        <h3>Welcome to MyStrengthBook University</h3>
        <p className="p5">
          Learn how to use the platform to become a more efficient coach
        </p>
      </header>
      <div className="sub-header">
        <SearchBar query={query} onChange={handleSearchBar} />
        <ProductSelector
          selected={product}
          hasFreeTrial={hasFreeTrial}
          isActivePull={isActivePull}
          isActivePush={isActivePush}
        />
      </div>
      <section>
        {filteredCategories.map((category, idx) => {
          return (
            <CategoryItem
              name={category.name}
              tutorials={getCategoryVideos(category.name)}
              key={idx}
            />
          );
        })}
        {!filteredCategories.length && query.length ? (
          <CategoryItem name={query} noResults />
        ) : null}
      </section>
    </main>
  );
};

export default MSBUniversity;
